<i18n>
{
  "ru":{
    "logout": "Выход",
    "help": "Справка",
    "support": "Техническая поддержка",
    "write_to_support": "Написать в техподдержку",
    "search_no_results": "По Вашему запросу ничего не найдено"
  },
  "en":{
    "logout": "Logout",
    "help": "Help",
    "support": "Technical support",
    "write_to_support": "Contact technical support",
    "search_no_results": "No results for your search were found"
  }
}
</i18n>

<template>
  <el-container>
    <div
      class="menu-overlay"
      :class="{ active: open }"
      v-if="!isLargeScreen"
      @click.prevent="toggleMenu()"
    ></div>
    <aside class="app-menu" :class="{ closed: !open }">
      <header>
        <div class="logo-wrap">
          <div class="logo--top">
            <router-link :to="{ name: 'dashboard' }">
              <img src="../../../assets/img/logo.svg" alt="WebPay" />
            </router-link>
          </div>
        </div>
      </header>
      <el-menu>
        <div
          v-for="(item, index) in items.filter(i => !i.check || i.check())"
          :key="index"
        >
          <el-menu-item
            v-if="!item.childs"
            :index="index.toString()"
            @click="menuClick(item)"
          >
            {{ $t(item.text) }}
          </el-menu-item>
          <el-submenu v-if="item.childs" :index="index.toString()">
            <template slot="title">
              {{ $t(item.text) }}
            </template>
            <el-menu-item
              v-for="(child, childIndex) in item.childs.filter(i => !i.check || i.check())"
              :index="index + '-' + childIndex"
              :key="childIndex"
              @click="menuClick(child)"
            >
              {{ $t(child.text) }}
            </el-menu-item>
          </el-submenu>
        </div>
      </el-menu>
    </aside>
    <el-container>
      <el-row>
        <el-col :span="24">
          <technical-alert></technical-alert>
        </el-col>
      </el-row>
      <el-header>
        <el-row type="flex" class="header-navigation aligner">
          <el-col class="aligner left">
            <el-button
              type="primary"
              circle
              icon="el-icon-menu"
              @click.prevent="toggleMenu()"
            ></el-button>
            <el-breadcrumb style="margin-left: 10px">
              <el-breadcrumb-item>
                <strong>
                  {{ $t($route.meta.title) }}
                </strong>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <el-col class="aligner right">
            <el-row type="flex" :gutter="10" class="user-menu">
              <el-col class="aligner right system-info">
                <system-info></system-info>
              </el-col>
              <el-col class="aligner right">
                <el-popover placement="bottom" width="200" trigger="hover">
                  <ul class="user__menu_list">
                    <li class="user__menu_sub">
                      <a href="https://docs.webpay.by/" target="_blank">
                        {{ $t("help") }}
                      </a>
                    </li>
                    <li class="user__menu_sub">
                      <a href="mailto:support@webpay.by">
                        {{ $t("write_to_support") }}
                      </a>
                    </li>
                    <li class="user__menu_sub">
                      <a href="#" @click.prevent="oldVersion()">
                        {{ $t("old_version") }}
                      </a>
                    </li>
                    <li class="user__menu_sub_phone border-top">
                      {{ $t("support") }}:
                      <a href="tel:+375293837172">+375 29 383 71 72</a>
                    </li>
                  </ul>
                  <div slot="reference" class="user__menu_help">
                    <a href="#"></a>
                  </div>
                </el-popover>
              </el-col>
              <!-- <el-col class="aligner right">
                <el-popover
                  placement="bottom"
                  width="200"
                  trigger="hover"
                >
                  <ul class="user__menu_sub">
                    <li>
                      <a href="#">выполнен вход</a>
                    </li>
                    <li>
                      <a href="#">оплата счета номер 00000</a>
                    </li>
                  </ul>
                  <div
                    slot="reference"
                    class="user__menu_ivents"
                  >
                    <span class="user__menu_ivents_notification">100</span>
                  </div>
                </el-popover>
              </el-col>-->
              <el-col>
                <div class="user__menu_user-info aligner right">
                  <span class="user__menu_user-info-company">
                    {{ username }}
                  </span>
                  <a
                    href="#"
                    class="user__menu_user-info-exit"
                    @click.prevent="logout()"
                  >
                    {{ $t("logout") }}
                  </a>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="aligner right system-info small">
          <system-info></system-info>
        </el-row>
      </el-header>
      <el-main>
        <transition name="fade" mode="out-in">
          <router-view :key="$route.fullPath" />
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import { appMenu } from '../router'
import authSvc from '../../core/authSvc'
import { eventBus } from '../../event-bus'

export default {
  name: 'home',
  data: () => ({
    items: appMenu,
    open: false,
    isLargeScreen: false,
    username: null
  }),
  beforeCreate () { },
  created () {
    this.username = authSvc.curUser
    this.$nextTick(function () {
      let setWidth = () => {
        this.isLargeScreen = document.documentElement.clientWidth >= 1200
        this.open = this.isLargeScreen
      }

      window.addEventListener('resize', setWidth)
      setWidth()
    })
  },
  methods: {
    toggleMenu () {
      this.open = !this.open
    },
    menuClick (item) {
      if (item.route) {
        if (item.route === this.$router.currentRoute.name) {
          eventBus.$emit('reload', item.route)
          if (!this.isLargeScreen) {
            this.toggleMenu()
          }
        } else {
          this.$router.push({ name: item.route })
        }
      } else if (item.href) {
        location.replace(item.href)
      } else if (item.action) {
        switch (item.action) {
          case 'reports':
            this.$alert('<p class="smile" style="margin: auto"></p><p style="font-size: 18px;margin: 35px 0;">Извините за временные неудобства, отчеты временно недоступны, мы работаем над улучшением данного раздела.</p><p>Для формирования отчета по операциям ЕРИП и по карточкам используйте, пожалуйста, ссылку <a href="https://merchant.webpay.by/arm/">https://merchant.webpay.by/arm/</a></p>',
              '',
              { showConfirmButton: false, dangerouslyUseHTMLString: true, center: true, customClass: 'reports' }
            )
            break
        }
      }
    },
    logout () {
      authSvc.logout()
      this.$router.push({ name: 'login' })
    },
    oldVersion () {
      document.cookie = 'j=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
      document.cookie = 'o=true'
      location.assign(location.origin)
    }
  },
  watch: {
    $route () {
      if (!this.isLargeScreen) {
        this.open = false
      }
    }
  }
}
</script>

<style>
.input-no-padding > input {
  padding: 0;
  text-align: center;
}

input[type="number"] {
  padding-right: 0;
}

.user__menu_list {
  margin: 0;
  padding: 0;
}

.user-menu {
  align-items: center;
}

.user-menu > span {
  list-style: none;
  display: block;
  float: left;
  margin: 10px 5px;
  padding: 4px;
  position: relative;
}

.user__menu_help {
  width: 24px;
  height: 32px;
  background: url(../invoices/img/help.svg) no-repeat;
  background-size: 100%;
}

.user__menu_ivents {
  width: 24px;
  height: 31px;
  background: url(img/bell.png) no-repeat;
  background-size: 100%;
  position: relative;
}

.user__menu_list li {
  list-style: none;
  display: block;
  color: #c1c1c1;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 300;
  transition: 0.5s;
}

.user__menu_sub:hover {
  background-color: #00abec;
}

.user__menu_sub > a {
  color: #333333;
  text-decoration: none;
  padding: 8px 0;
  display: block;
}

.user__menu_sub:hover > a {
  color: #ffffff;
  transition: 0.5s;
  padding: 8px 5px;
}

.user__menu_sub_phone a {
  display: block;
  color: #00abec;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 300;
  margin: 8px;
}

.user__menu_sub_phone {
  margin-top: 16px;
  margin-bottom: 5px;
}

.user__menu_ivents_notification {
  width: 19px;
  height: 19px;
  background-color: #fe9292;
  display: block;
  border-radius: 100%;
  color: #ffffff;
  font-family: "Roboto", sans-serif;
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  top: 0;
  right: -8px;
  padding: 1px;
}

.user__menu_user-info {
  padding: 0;
  flex-direction: column;
  align-items: flex-start;
}

.user__menu_user-info-company {
  color: #333333;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 500;
  height: 18px;
}

.user__menu_user-info-exit {
  font-size: 12px;
  font-weight: 500;
  color: #00abec;
  text-decoration: none;
}

.el-main,
.header-navigation {
  margin: auto;
  width: 100%;
}

/*-* Header *-*/
header {
  height: 40px;
  padding: 10px;
}

.el-header {
  height: 60px;
  padding: 5px 16px;
  background-color: #ffffff;
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
}

.logo--top a img {
  height: 50px;
  border: none;
  margin-right: 20px;
}

.logo-wrap {
  max-width: 250px;
  margin-right: 35px;
  background: white;
  width: 100%;
}

/*-* ------ Header nav ---------- *-*/

.spacer {
  margin: 50px 0;
}

.app-menu {
  width: 250px;
  height: 100%;
  position: fixed;
  left: 0;
  z-index: 2001;
  transform: translate3d(0, 0, 0);
  transition: 0.3s;
  background: white;
}

.app-menu > .el-menu {
  height: 100%;
}

.app-menu.closed {
  transform: translate3d(-100%, 0, 0);
}

.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  z-index: 5;
}

.menu-overlay.active {
  pointer-events: unset;
}

.menu-overlay:before {
  background-color: #212121;
  bottom: 0;
  content: "";
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: inherit;
  transition-delay: 150ms;
  width: 100%;
}

.menu-overlay.active::before {
  opacity: 0.4;
}

.el-container {
  display: block;
}

.card_brand {
  background-image: url(../../../assets/img/card_logo/none_logo.svg);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  height: 40px;
  width: 80px;
  float: left;
}

.card_brand.visa {
  background-image: url(../../../assets/img/card_logo/visa.svg);
}
.card_brand.mastercard {
  background-image: url(../../../assets/img/card_logo/mastercard.svg);
}
.card_brand.belcard {
  background-image: url(../../../assets/img/card_logo/belcard.svg);
}
.card_brand.belqi {
  background-image: url(../../../assets/img/card_logo/belqi.svg);
}

.el-message-box.reports {
  width: 300px;
}

@media screen and (min-width: 768px) {
  .el-message-box.reports {
    width: 700px;
  }

  .el-message-box.reports .el-message-box__content {
    padding: 50px 120px;
  }
  .el-table.old td,
  th {
    padding: 10px;
    text-align: left;
    font-size: 14px;
  }

  .el-table.old th {
    background: #c1c1c1;
    color: white;
    font-weight: bold;
  }

  .el-table.small td,
  .el-table.small th {
    padding: 3px;
    font-size: 12px;
  }
}

@media screen and (min-width: 1200px) {
  .app-menu:not(.closed) + .el-container {
    padding-left: 250px;
    transition: 0.3s;
  }
}

@media screen and (max-width: 1200px) {
  .logo--top a img {
    height: 40px;
  }
}

.system-info.small {
  display: none;
}

.system-info:not(.small) {
  display: unset;
}

@media screen and (max-width: 768px) {
  .el-date-picker.has-sidebar.has-time {
    width: 325px;
  }

  .el-date-picker.has-sidebar.has-time .el-picker-panel [slot="sidebar"],
  .el-date-picker.has-sidebar.has-time .el-picker-panel__sidebar {
    top: unset;
    width: 100%;
  }

  .el-date-picker.has-sidebar.has-time .el-picker-panel__shortcut {
    width: auto;
    float: right;
  }

  .el-date-picker.has-sidebar.has-time .el-picker-panel [slot="sidebar"] + .el-picker-panel__body,
  .el-date-picker.has-sidebar.has-time .el-picker-panel__sidebar + .el-picker-panel__body {
    margin-left: 0;
    margin-bottom: 26px;
  }

  .el-header {
    height: auto !important;
  }

  .el-form--inline .el-form-item__label {
    display: block;
  }

  .system-info.small {
    display: unset;
  }

  .system-info:not(.small) {
    display: none;
  }
}

@media only screen and (max-device-width: 1200px) {
  .user__menu_user-info {
    min-width: 130px;
  }
  .logo--top a img {
    height: 40px;
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .logo--top,
  .logo--top a img {
    width: 100px;
  }

  .el-header {
    padding: 10px 6px;
  }

  .header-navigation .el-breadcrumb {
    display: none;
  }
}
</style>
